module.exports = __webpack_public_path__ + "img/coin-available.e49c51ed.png";